<template>
  <div class="publicMain">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" class="demo-ruleForm">
      <div class="baseTitle">基本信息</div>
      <!--  -->
      <div class="top">
        <el-row>
          <el-col :span="8">
            <el-form-item label="机构名称" prop="name">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="charge">
              <el-input v-model="form.charge"></el-input>
            </el-form-item>
            <el-form-item label="机构类型" prop="type">
              <el-select v-model="form.type"  style="width:100%" disabled>
                <el-option label="机构养老" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房产所有权属" prop="house">
              <el-select v-model="form.house"  style="width:100%">
                <el-option label="私有" :value="1"></el-option>
                <el-option label="公有" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="房屋性质" prop="houseNature">
              <el-select v-model="form.houseNature"  style="width:100%">
                <el-option label="自建" :value="1"></el-option>
                <el-option label="租赁" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="建筑面积" prop="area">
              <el-input v-model="form.area"></el-input>
            </el-form-item>
            <el-form-item label="床位数" prop="beds">
              <el-input v-model="form.beds"></el-input>
            </el-form-item>
            <el-form-item label="管理人员数" prop="administrators">
              <el-input v-model="form.administrators"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="placehold"></div>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构介绍" prop="introduce">
              <el-input v-model="form.introduce"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="phone">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="性质" prop="nature">
              <el-select v-model="form.nature"  style="width:100%">
                <el-option label="公建公营" :value="1"></el-option>
                <el-option label="社会办" :value="2"></el-option>
                <el-option label="公建民营" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="土地性质" prop="land">
              <el-select v-model="form.land"  style="width:100%">
                <el-option label="划拨" :value="1"></el-option>
                <el-option label="有偿出让" :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="建设年份" prop="years">
              <el-date-picker
                      v-model="form.years"
                      type="date"
                      placeholder="选择日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="实际入住人数" prop="checks">
              <el-input v-model="form.checks"></el-input>
            </el-form-item>
            <el-form-item label="已预约数" prop="reserveds">
              <el-input v-model="form.reserveds"></el-input>
            </el-form-item>
            <el-form-item label="护理人员数" prop="attendant">
              <el-input v-model="form.attendant"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="placehold"></div>
          </el-col>

        </el-row>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="form.address"></el-input>
        </el-form-item>
        <el-form-item label>
          <div id="container" style="width:550px;height:400px;" ></div>
        </el-form-item>
        <el-form-item label="图片">
          <upload :fileLists="fileList" :type="typeImg" @success="successImg" @deleteImg="deleteImg" />
        </el-form-item>
      </div>

      <div class="button">
        <div class="button-mid" v-if="query.buttonType!='check'">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button type="info" @click="back">返回</el-button>
        </div>
        <div class="button-mid" v-else>
          <el-button type="info" @click="back">返回</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
  import {
    organizationInfoEdit,
    organizationInfoCheck,

  } from "../api/index.js";
import upload from "@/component/componentsP/upImg.vue";
export default {
  components: {
    upload
  },
  data() {
    return {
      visible: false, //dialog的标题
      //模糊查询数据
      form: {
        type:'0'
      },
      fileList: [],
      typeImg: "",
      //table表格的column
      rules: {
        name: [{ required: true, message: "请输入机构名称", trigger: "blur" }],
        // startTime: [{ required: true, message: "请输入标题", trigger: "blur" }],
        charge: [{ required: true, message: "请输入负责人", trigger: "blur" }],
        type: [{ required: true, message: "请选择机构类型", trigger: "blur" }],
        address: [{ required: true, message: "请输入详细地址", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" }
        ]
      },
      query:{},
    };
  },
  methods: {
    //保存按钮
    save() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let photo = "";
          this.fileList.forEach(item => {
            photo += item.path + ";";
          });
          this.$set(this.form, "photo", photo);
          organizationInfoEdit(this.form).then(res => {
            this.$message({
              type: "success",
              message: this.form.id?"编辑成功":"保存成功"
            });
            this.$router.push({
              path: "/provideOrganization"
            });
          });
        }
      });
    },
    //回写拿到数据
    getData(e) {
      organizationInfoCheck(e).then(res => {
        this.form = res.content;
        if (res.content.photo) {
          let arr = res.content.photo.split(";");
          arr.pop();
          this.fileList = arr.map(item => {
            return {
              path: item,
              name: item
            };
          });
          this.typeImg = "compile";
          this.$nextTick(() => {
            // this.viewMapTemp = true
            this.mapInit("container");
          });
        }
      });
    },
    //返回
    back() {
      this.$router.push({
        path: "/provideOrganization"
      });
    },
    successImg(e) {
      this.fileList = e;
    },

    deleteImg(e) {
      this.fileList = e;
    },
    //根据输入地址转换经纬度并标记
    transLocation() {
      var searchKey = this.form.address;
      var map = new AMap.Map("container", {
        resizeEnable: true,
        zoom: 18,
      });
      var that = this;
      AMap.plugin("AMap.Geocoder", function () {
        var geocoder = new AMap.Geocoder({
          radius: 1000,
          extensions: "all",
        });
        var marker = new AMap.Marker();
        geocoder.getLocation(searchKey, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            var lnglat = result.geocodes[0].location;
            that.form.longitude =String(lnglat.lng) ;
            that.form.latitude =String( lnglat.lat);
            marker.setPosition(lnglat);
            map.add(marker);
            map.setFitView(marker);
          } else {
            that.$message({
              message: "获取坐标失败，请手动获取",
              type: "error",
            });
          }
        });
      });
      var geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });
      map.on("click", function (e) {
        console.log("e", e);
        that.form.longitude = e.lnglat.getLng();
        that.form.latitude = e.lnglat.getLat();
        geocoder.getAddress(
                e.lnglat.getLng() + "," + e.lnglat.getLat(),
                function (status, result) {
                  if (status === "complete" && result.regeocode) {
                    console.log("result", result);
                    var address = result.regeocode.formattedAddress;
                    // that.form.address = address;
                    that.$set(that.form, "address", address);
                  } else {
                    log.error("根据经纬度查询地址失败");
                  }
                }
        );
      });
    },
    //初始化地图插件的方法
    mapInit(containerId) {
      var map = new AMap.Map(containerId, {
        resizeEnable: true,
        zoom: 18,
      });
      if (this.form.longitude != undefined && this.form.latitude != undefined) {
        var marker = new AMap.Marker({
          position: [Number(this.form.longitude) ,Number(this.form.latitude)],
          map: map,
        });
        map.setFitView(marker);
      } else {
        AMap.plugin("AMap.Geolocation", function () {
          //异步定位当前
          var geolocation = new AMap.Geolocation();
          map.addControl(geolocation);
        });
      }
      //定义地图坐标点击事件
      var that = this;
      var geocoder = new AMap.Geocoder({
        city: "010", //城市设为北京，默认：“全国”
        radius: 1000, //范围，默认：500
      });
      map.on("click", function (e) {
        that.form.longitude =String(e.lnglat.getLng()) ;
        that.form.latitude =String(e.lnglat.getLat()) ;
        geocoder.getAddress(
                e.lnglat.getLng() + "," + e.lnglat.getLat(),
                function (status, result) {
                  if (status === "complete" && result.regeocode) {
                    var address = result.regeocode.formattedAddress;
                    // that.form.address = address;
                    that.$set(that.form, "address", address);
                  } else {
                    log.error("根据经纬度查询地址失败");
                  }
                }
        );
      });
    },
  },
  created() {
    console.log(this.$route)
    this.query = {
      id: this.$route.query.id,
      buttonType: this.$route.query.buttonType,
      row: JSON.parse(this.$route.query.row),
    };
    this.getData({ id: this.query.id });
  }
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  margin-top: 20px;
}
.table {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  height: 500px;
  overflow: auto;
  margin: auto;
}
.add {
  margin: 20px 0px;
}
.icon-icon7 {
  color: #dd3020;
}
.icon-tongguos {
  color: #0d5795;
}
.baseTitle {
  background-color: rgb(242, 242, 242);
  font-weight: 700;
  color: #000;
  font-size: 14px;
  padding: 10px 0px 10px 10px;
  margin-bottom: 20px;
}
.placehold {
  width: 100%;
  height: 10px;
}
.button-mid {
  width: 300px;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
}
</style>
